var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "navigation", attrs: { id: "main-navigation-wrapper" } },
    [
      _c("div", {
        staticClass:
          "position-fixed overflow-hidden background-overlay d-lg-none",
        on: { click: _vm.closeNavigation },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "navigation-wrapper px-lg-5" }, [
        _c(
          "div",
          { staticClass: "navigation-wrapper-container" },
          [
            _c(
              "div",
              {
                staticClass:
                  "navigation-header d-flex align-items-center justify-content-between d-lg-none",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center navigation-header-gap",
                  },
                  [
                    _vm._t("language-change"),
                    _vm._v(" "),
                    _vm._t("showroom-tour"),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "close-navigation d-flex align-items-center cursor-pointer",
                    attrs: { type: "button", "aria-label": "Close Navigation" },
                    on: {
                      click: function ($event) {
                        return _vm.closeNavigation()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M15 5L5 15M5 5L15 15",
                            stroke: "#363636",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._t("my-account"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "menu-banner-top menu-banner-buttons p-3 d-flex justify-content-between align-items-center overflow-hidden d-lg-none",
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "w-100",
                    attrs: {
                      href: _vm.links.NewHitsLink,
                      "aria-label": _vm.multiLanguage.HeaderNew,
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-new w-100",
                        attrs: { type: "button" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.multiLanguage.HeaderNew) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "w-100",
                    attrs: {
                      href: _vm.links.BestSellerLink,
                      "aria-label": _vm.multiLanguage.BestSeller,
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-bestseller w-100",
                        attrs: { type: "button" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.multiLanguage.BestSeller) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "w-100",
                    attrs: {
                      href: _vm.links.SaleLink,
                      "aria-label": _vm.multiLanguage.Sale,
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sale w-100",
                        attrs: { type: "button" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.multiLanguage.Sale) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass:
                  "navigation-bar d-flex align-items-center pt-1 justify-content-center",
              },
              [
                _c("li", { staticClass: "navigation-item" }, [
                  _c(
                    "div",
                    { staticClass: "mega-menu-wrapper pl-0" },
                    [_vm._t("all-rugs")],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "navigation-item" }, [
                  _c("div", { staticClass: "mega-menu-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "menu-title font-weight-medium flex-row d-flex align-items-center justify-content",
                        on: {
                          click: function ($event) {
                            return _vm.setActiveTab("oriental_rugs")
                          },
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "title text-decoration-none",
                            attrs: { href: _vm.links.OrientRugs },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.multiLanguage.OrientRugs) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "d-lg-none chevron-icon",
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9 18L15 12L9 6",
                                stroke: "#4b5565",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mega-menu-container sub-menu-container",
                        class: { "menu-active": _vm.tabs.oriental_rugs },
                      },
                      [
                        _c("oriental-rugs", {
                          attrs: { "multi-language": _vm.multiLanguage },
                          on: {
                            "close-tab": _vm.closeAllTabs,
                            "close-navigation": _vm.closeNavigation,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "main-oriental-content",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "px-3 py-2 d-lg-none" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "main-link d-block text-center mb-0 position-relative font-weight-medium text-underline",
                                            attrs: {
                                              href: _vm.links.OrientRugs,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.multiLanguage
                                                    .HomepageShowAll
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._t("oriental-rugs"),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "navigation-item" }, [
                  _c("div", { staticClass: "mega-menu-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "menu-title font-weight-medium flex-row d-flex align-items-center justify-content",
                        on: {
                          click: function ($event) {
                            return _vm.setActiveTab("modern_rugs")
                          },
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "title text-decoration-none",
                            attrs: { href: _vm.links.ModerneRugs },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.multiLanguage.ModerneRugs) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "d-lg-none chevron-icon",
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9 18L15 12L9 6",
                                stroke: "#4b5565",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mega-menu-container sub-menu-container",
                        class: { "menu-active": _vm.tabs.modern_rugs },
                      },
                      [
                        _c("modern-rugs", {
                          attrs: { "multi-language": _vm.multiLanguage },
                          on: {
                            "close-tab": _vm.closeAllTabs,
                            "close-navigation": _vm.closeNavigation,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "main-modern-content",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "px-3 py-2 d-lg-none" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "main-link d-block text-center mb-0 position-relative font-weight-medium text-underline",
                                            attrs: {
                                              href: _vm.links.ModerneRugs,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.multiLanguage
                                                    .HomepageShowAll
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._t("modern-rugs"),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "navigation-item" }, [
                  _c(
                    "div",
                    { staticClass: "mega-menu-wrapper" },
                    [_vm._t("woven-rugs")],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "navigation-item d-block nav-xl-items" },
                  [
                    _c(
                      "div",
                      { staticClass: "mega-menu-wrapper" },
                      [_vm._t("outlet-rugs")],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "navigation-item" }, [
                  _c("div", { staticClass: "mega-menu-wrapper pr-0" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "menu-title font-weight-medium sale-title text-white flex-row d-flex align-items-center justify-content px-0",
                        on: {
                          click: function ($event) {
                            return _vm.setActiveTab("sale")
                          },
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-white text-decoration-none text-uppercase",
                            attrs: { href: _vm.links.SaleLink },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.multiLanguage.Sale) +
                                " %\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "d-lg-none chevron-icon",
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9 18L15 12L9 6",
                                stroke: "#4b5565",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mega-menu-container sub-menu-container",
                        class: { "menu-active": _vm.tabs.sale },
                      },
                      [
                        _c("sale", {
                          attrs: { "multi-language": _vm.multiLanguage },
                          on: {
                            "close-tab": _vm.closeAllTabs,
                            "close-navigation": _vm.closeNavigation,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "main-sale-content",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "px-3 py-2 d-lg-none" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "main-link d-block text-center mb-0 position-relative font-weight-medium text-underline",
                                            attrs: { href: _vm.links.SaleLink },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.multiLanguage
                                                    .HomepageShowAll
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._t("main-sale"),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "navigation-item" }, [
                  _c(
                    "div",
                    { staticClass: "mega-menu-wrapper" },
                    [_vm._t("blogs")],
                    2
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm._t("navigation-footer"),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }